<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 21 17" fill="none">
    <path d="M2.9511 10.1158C2.9511 10.8057 3.10245 11.3353 3.30041 11.6557C3.5599 12.0754 3.9469 12.2535 4.34146 12.2535C4.8503 12.2535 5.31585 12.1272 6.21297 10.8864C6.93188 9.89184 7.7786 8.49587 8.34843 7.6207L9.31343 6.13801C9.98375 5.10831 10.7596 3.96366 11.6493 3.18777C12.3757 2.55445 13.159 2.20264 13.9474 2.20264C15.2712 2.20264 16.5321 2.96975 17.4971 4.40847C18.5532 5.98409 19.0658 7.9688 19.0658 10.0169C19.0658 11.2345 18.8259 12.1291 18.4174 12.8359C18.0229 13.5194 17.2539 14.2023 15.9604 14.2023V12.2532C17.068 12.2532 17.3444 11.2354 17.3444 10.0706C17.3444 8.41074 16.9574 6.56875 16.1048 5.25254C15.4999 4.31895 14.7158 3.74851 13.8532 3.74851C12.9202 3.74851 12.1695 4.45229 11.3257 5.70674C10.8771 6.37336 10.4166 7.18565 9.89953 8.10229L9.3303 9.11065C8.18701 11.1384 7.89733 11.6 7.32561 12.3619C6.3236 13.6961 5.46788 14.202 4.34146 14.202C3.00513 14.202 2.16015 13.6233 1.63678 12.7514C1.2096 12.0408 0.999756 11.1085 0.999756 10.0461L2.9511 10.1158Z" 
    fill="#0081FB"/>
    <path d="M2.53833 4.5458C3.43295 3.16679 4.72404 2.20239 6.20483 2.20239C7.06238 2.20239 7.91508 2.4562 8.80516 3.18313C9.77894 3.97772 10.8168 5.28688 12.1117 7.4436L12.5759 8.21738C13.6968 10.0846 14.3344 11.0452 14.7076 11.4982C15.1875 12.0799 15.5237 12.2533 15.9603 12.2533C17.068 12.2533 17.3443 11.2355 17.3443 10.0707L19.0658 10.0167C19.0658 11.2343 18.8258 12.1289 18.4174 12.8357C18.0229 13.5192 17.2539 14.2022 15.9603 14.2022C15.1561 14.2022 14.4437 14.0275 13.6559 13.2842C13.0505 12.7138 12.3422 11.7004 11.7975 10.7895L10.1772 8.08298C9.36432 6.7247 8.61832 5.71195 8.18697 5.25328C7.72264 4.76004 7.12579 4.16448 6.17335 4.16448C5.40253 4.16448 4.74787 4.7054 4.20007 5.53282L2.53833 4.5458Z" 
    fill="url(#paint0_linear_23880_3254)"/>
    <path d="M6.17339 4.16448C5.40257 4.16448 4.74791 4.7054 4.2001 5.53282C3.42542 6.702 2.95148 8.44349 2.95148 10.1159C2.95148 10.8057 3.10282 11.3353 3.30079 11.6557L1.63678 12.7514C1.2096 12.0409 0.999756 11.1085 0.999756 10.0462C0.999756 8.11431 1.53001 6.10076 2.53837 4.5458C3.43299 3.16679 4.72407 2.20239 6.20487 2.20239L6.17339 4.16448Z" 
    fill="url(#paint1_linear_23880_3254)"/>
    <defs>
      <linearGradient id="paint0_linear_23880_3254" x1="4.91602" y1="7.89129" x2="17.3554" y2="8.51954" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0064E1"/>
        <stop offset="0.4" stop-color="#0064E1"/>
        <stop offset="0.83" stop-color="#0073EE"/>
        <stop offset="1" stop-color="#0082FB"/>
      </linearGradient>
      <linearGradient id="paint1_linear_23880_3254" x1="3.60228" y1="10.9351" x2="3.60228" y2="6.3489" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0082FB"/>
        <stop offset="1" stop-color="#0064E0"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'MetaIcon',
  props: {
    width: {
      type: Number,
      default: 21,
    },
    height: {
      type: Number,
      default: 17,
    }
  }
}
</script>

<style scoped></style>